import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionState } from '../state/session.state';

/**
 * Guard para proteger rutas privadas.
 * Redirige a /auth/login si el usuario no está autenticado.
 */
export const authGuard: CanActivateFn = () => {
  const session = inject(SessionState);
  const router = inject(Router);
  
  if (session.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/auth/login']);
};
